 
 import apiClient from "../../admin/api/apiClient";
 
 const API_PATH = process.env.REACT_APP_API_PATH;
 
  export interface FlashSale {
  
    flashSaleID: number;
  
    title: string;
  
    discount: number;
  
    startTime: string;
  
    endTime: string;
  
    status: "upcoming" | "live" | "ended";
  
    banner: string;
  
    saleLabel?: string;
  
    saveUpTo: number;
  
    saleImageUrl?: string;
  
    saleImageFile?: File | null;
  
    isActive: boolean;
  
    // ======================================
    // PRODUCT IDS
    // ======================================
  
    productIDs?: number[];
  
    // ======================================
    // PRODUCT NAMES
    // ======================================
  
    products?: Product[];
  }
  // ==========================================
// PRODUCT TYPE
// ==========================================

export interface Product {

  productID: number;

  productName: string;
}
// ==========================================
// API RESPONSE
// ==========================================

export interface ApiResponse<T> {

  loggingHistoryID?: number;

  statusCode: number;

  isSuccess: boolean;

  message: string;

  errors?: string[];

  data?: T;

  dataList?: T[];
}

// ==========================================
// API BASE URL
// ==========================================

const API_URL =
  "/Public";
export const flashSaleService = {
    // ======================================
  // GET ALL
  // ======================================
  getAll: async (): Promise<FlashSale[]> => {

    const response =
      await apiClient.get<
        ApiResponse<FlashSale>
      >(
        `${API_URL}/GetFlashSale`
      );

    const result =
      response.data;

    console.log(
      "Flash Sale Data List:",
      result.dataList
    );

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },
}
 